import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HeaderItemModel } from '../model/header-item.model';
import { HeaderDefaultModel } from '../model/header-default.model';

@Injectable()
export class HeaderDefaultService {

    path = '/header-default';

    constructor(private baseService: BaseService) {}

    findByChecklistId(checklistId: number) {
        return this.baseService.get(this.path, '/by-checklist/' + checklistId);
    }

    save(headerDefault) {

        return this.post(headerDefault)
    }

    post(headerDefault) {
        return this.baseService.post(this.path, '/', headerDefault);
    }

    put(headerDefault: HeaderDefaultModel) {
        return this.baseService.put(this.path, '/', headerDefault);
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id);
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/header-default.service.ts